<template>
  <h1>PROMOS</h1>
  <div class="cards">
    <div class="card" v-for="item in items" :key="item">
      <h2>{{ item.name }}</h2>
      <img :src="item.image" alt="item.name" loading="lazy" />
      <p>{{ item.description }}</p>
      <p v-html="item.price"></p>
      <a href="#contact"><button>VER MÁS</button></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CxPromos",
  data() {
    return {
      items: [
        {
          name: "PROMO ✨ Páginas Web Personalizada",
          image: require("@/assets/images/web site.jpg"),
          description:
            "🌐 Web personalizada que cautiva y deslumbra. Eleva tu marca con diseño web de vanguardia. ¡Destaca en línea y atrae a tu audiencia con un sitio único!",
          price: "<strong>$ 100 DOLARES</strong>",
        },
        {
          name: "PROMO ✨ Ciencia de Datos",
          image: require("@/assets/images/data science.jpg"),
          description:
            "🚀 Desbloquea conocimientos ocultos en tus datos con nuestra Ciencia de Datos. Potencia tu toma de decisiones y maximiza el rendimiento. ¡Transforma datos en éxito!",
          price: "<strong>$ 120 DOLARES</strong>",
        },
        {
          name: "PROMO ✨ Marketing Digital",
          image: require("@/assets/images/digital marketing.jpg"),
          description:
            "📣 Conquista las redes con nuestros Agencia de Marketing Digital. Acelera tu alcance con estrategias de Marketing Digital y un diseño que deslumbra. ¡Domina lo digital ahora!",
          price: "<s>$ 100 dolares</s> <strong>$ 50 DOLAR x Mes</strong>",
        },
      ],
    };
  },
};
</script>

<style scoped>
.cards {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
}

h1 {
  color: var(--color-accent);
  font-family: var(--font-sans);
  font-size: 2.5rem;
  font-weight: bold;
  margin: 20px auto;
}

.card {
  width: 90vw;
  border: 1px solid var(--color-accent);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

h2 {
  color: var(--color-primary);
  font-family: var(--font-homenaje);
  font-size: 1.5rem;
}

img {
  width: 100%;
  max-width: 300px;
  border-radius: 10px;
  margin: 10px;
}

p {
  color: var(--color-accent);
  font-size: 1rem;
  font-family: var(--font-sans);
}

button {
  background-color: var(--color-accent);
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  width: 70vw;
  cursor: pointer;
}

button:hover {
  background-color: var(--color-primary);
}

button a {
  text-decoration: none;
  color: var(--color-background);
  font-family: var(--font-sans);
  font-weight: bold;
}

@media (min-width: 768px) {
  .card {
    width: 60vw;
  }

  button {
    width: 50vw;
  }
}

@media (min-width: 1024px) {
  .cards {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-around;
    width: 80vw;
    margin: auto;
  }

  .card {
    width: 30vw;
    min-height: 600px; /* Altura fija para tarjetas en pantallas grandes */
    margin: 10px;
  }

  h1 {
    font-size: 4rem;
  }

  h2 {
    font-size: 2rem;
  }

  p {
    font-size: 1.2rem;
  }

  button {
    width: 20vw;
  }
}
</style>
